import { render } from "./search.vue?vue&type=template&id=356fc927"
import script from "./search.js?vue&type=script&lang=js&external"
export * from "./search.js?vue&type=script&lang=js&external"

import "./search.vue?vue&type=style&index=0&id=356fc927&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__